export const allWorkspaceSeatTypes = [
    "Full",
    "Builder",
    "None",
];
